<template>
  <AccountNotFound
    v-if="isAccountNotFound"
    :account-number="current.accountNumber"
  />

  <router-view v-else-if="isAccountFetched"></router-view>

  <v-main v-else class="d-flex flex-column align-center justify-center">
    <SoLoader />
    <h3 class="text-h3 mt-8">Loading customer account</h3>
  </v-main>
  <ModalHandler />
</template>

<script lang="ts">
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { defineComponent } from "vue"
  import SoLoader from "@/components/SoLoader.vue"
  import ModalHandler from "./overview/modals/ModalHandler.vue"
  import AccountNotFound from "./AccountNotFound.vue"

  export default defineComponent({
    components: {
      SoLoader,
      ModalHandler,
      AccountNotFound,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      isAccountNotFound() {
        return (
          this.current.coreId.isFetched &&
          !this.current.coreId.isError &&
          this.current.coreId.data === null
        )
      },
      isAccountFetched() {
        return (
          !this.current.account.isError &&
          this.current.account.isFetched &&
          Object.keys(this.current.account.data).length > 0
        )
      },
    },
  })
</script>
